<template>
  <div ref="el">
    <pre :class="`language language-${language}`" v-html="getFormattedCode" />
    <div class="hidden">
      <login-panel class="absolute w-224 z-50" />
    </div>
  </div>
</template>

<script>
import Prism from 'prismjs'
import 'prismjs/components/prism-json'
import 'prismjs/components/prism-bash'
import 'prismjs/components/prism-markup-templating'
import 'prismjs/components/prism-php'
import 'prismjs/components/prism-ruby'
import 'prismjs/components/prism-python'
import 'prismjs/components/prism-csharp'
import 'prismjs/components/prism-java'
import 'prismjs/components/prism-go'
import 'prismjs/components/prism-scala'
import 'prismjs/components/prism-kotlin'
import 'prismjs/components/prism-groovy'

import injectCredentials from '@/scripts/InjectCredentials'

import LoginPanel from '@/components/LoginPanel'

export default {
  components: { LoginPanel },
  props: {
    code: {
      type: String,
      required: true
    },
    language: {
      type: String,
      default: 'json'
    }
  },
  computed: {
    getFormattedCode() {
      return injectCredentials(
        Prism.highlight(this.code, Prism.languages[this.language]),
        this.$store.state
      )
        .replace(/&lt;/g, '<')
        .replace(/&amp;/g, '&')
    }
  },
  mounted() {
    this.$nextTick(() => {
      const app = document.getElementById('app')
      const loginPanel = this.$refs.el.getElementsByClassName('login-panel')[0]
      const snippetWrapperInfo = this.$refs.el.getElementsByClassName(
        'snippet-wrapper-info'
      )

      document.addEventListener('click', e => {
        if (e.target && e.target.id === 'show-password') {
          document.getElementById('show-password').classList.add('hidden')
          document.getElementById('encrypted-password').classList.add('hidden')
          document.getElementById('api-key').classList.remove('hidden')
        }
      })

      let panelHovered = false

      if (snippetWrapperInfo.length) {
        Array.prototype.forEach.call(snippetWrapperInfo, el => {
          el.addEventListener('mouseover', e => {
            const position = e.target.getBoundingClientRect()
            loginPanel.style.bottom = `${app.offsetHeight - position.top}px`
            loginPanel.style.left = `${position.left}px`
            app.appendChild(loginPanel)
          })
          loginPanel.addEventListener('mouseover', () => {
            panelHovered = true
          })
          el.addEventListener('mouseleave', () => {
            setTimeout(() => {
              if (!panelHovered) {
                app.removeChild(loginPanel)
              }
            }, 100)
          })
          loginPanel.addEventListener('mouseleave', () => {
            if (panelHovered) {
              app.removeChild(loginPanel)
              panelHovered = false
            }
          })
        })
      }
    })
  }
}
</script>
